import { useCallback, useRef } from 'react';
import type { OnChangeStageSettings, OnCommitStageSettings, StageSettingsT } from '../types';
type UseStageSettingsParamsT = {
  stageSettings: StageSettingsT;
  setStageSettings: (value: StageSettingsT | ((prev: StageSettingsT) => StageSettingsT)) => void;
};
export function useStageSettings({
  stageSettings,
  setStageSettings
}: UseStageSettingsParamsT) {
  const liveSettingsRef = useRef<StageSettingsT>(stageSettings);
  const onChangeStageSettings = useCallback<OnChangeStageSettings>(value => {
    const updated = typeof value === 'function' ? value(liveSettingsRef.current) : value;
    if (updated === liveSettingsRef.current) return;
    liveSettingsRef.current = {
      ...liveSettingsRef.current,
      ...updated
    };
  }, []);
  const onCommitStageSettings = useCallback<OnCommitStageSettings>(value => {
    if (value !== undefined) onChangeStageSettings(value);
    setStageSettings(liveSettingsRef.current);
  }, [onChangeStageSettings, setStageSettings]);
  return {
    stageSettingsRef: liveSettingsRef,
    onChangeStageSettings,
    onCommitStageSettings
  };
}